export enum EMapService {
  TransportAccessibility = 'transportAccessibility',
  FutureInfrastructure = 'futureInfrastructure',
  Routes = 'routes',
}
